import React, { useState, useEffect } from "react";
import {
  uploadTemplateShift,
  getTemplateShifts,
  DeleteTemplateShifts,
} from "../api/template_shift";
import { GetRestaurants } from "../api/restaurant";

const AddTemplateShift = ({ token }) => {
  const [file, setFile] = useState("");
  const [statusFile, setStatusFile] = useState([]);
  const [restaurants, setRestaurants] = useState([]);

  const [selectedRestaurant, setSelectedRestaurant] = useState(null);
  const [selectedStartDate, setSelectedStartDate] = useState(null);
  const [selectedEndDate, setSelectedEndDate] = useState(null);
  const [loadedTemplateShifts, setLoadedTemplateShifts] = useState([]);
  const [deletedTemplateShifts, setDeletedTemplateShifts] = useState([]);
  const [haveTemplateShifts, setHaveTemplateShifts] = useState(false);
  const [message, setMessage] = useState();
  const [workSpinner, setWorkSpinner] = useState(true);
  const [haveFile, setHaveFile] = useState(false);

  const fetchAllRestaurants = async () => {
    try {
      const data = await GetRestaurants(token, 1, 50);
      setRestaurants(data.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchAllRestaurants();
  }, [token]);

  async function addFile(event) {
    setFile(event.target.files[0]);
    setHaveFile(true);
  }

  async function sendFile(event) {
    setMessage(<p>Создаются шаблоны смен</p>);
    const data = await uploadTemplateShift(token, file);
    setStatusFile(data["errors"]);
    setLoadedTemplateShifts(data["success"]);
    setWorkSpinner(false);
    setMessage(<p style={{ color: "green" }}>Создано!</p>);
  }

  async function loadTemplateShifts() {
    console.log(selectedRestaurant, selectedStartDate, selectedEndDate);
    if (!selectedRestaurant || !selectedStartDate || !selectedEndDate) {
      setMessage(<p style={{ color: "red" }}>Не все поля заполнены! </p>);
      setWorkSpinner(false);
      return;
    }

    const data = await getTemplateShifts(
      token,
      selectedRestaurant,
      selectedStartDate,
      selectedEndDate,
    );
    setDeletedTemplateShifts(data);
    // setLoadedTemplateShifts(data);
    if (data.length > 0) {
      setHaveTemplateShifts(true);
    } else {
      setHaveTemplateShifts(false);
    }
    setWorkSpinner();
    setMessage(
      <p style={{ color: "green" }}>Выгружено {data.length} шаблонов смен.</p>,
    );
  }

  function renderTempaleShift(ts) {
    if (ts) {
      return `${ts.date}. ${ts.start} - ${ts.end}. ${ts.station_name} ${ts.restaurant_name}`;
    }
  }

  function renderShift(s) {
    if (s) {
      return (
        <div
          className="text-center"
          style={{ background: "green", fontWeight: "bold" }}
        >
          Есть
        </div>
      );
    }
    if (!s)
      return (
        <div
          className="text-center"
          style={{ background: "red", fontWeight: "bold" }}
        >
          Нет
        </div>
      );
  }

  async function deleteTemplateShifts(event) {
    setMessage(<p>Удаляется ...</p>);
    if (!selectedRestaurant && !selectedStartDate && !selectedEndDate) {
      setMessage(<p style={{ color: "red" }}>Не все поля заполнены! </p>);
      setWorkSpinner(false);
      return;
    }
    const data = await DeleteTemplateShifts(
      token,
      selectedRestaurant,
      selectedStartDate,
      selectedEndDate,
    );
    if (data.detail) {
      setMessage(<p style={{ color: "red" }}>{data.detail}</p>);
    } else if (data.status_code == 200) {
      setDeletedTemplateShifts([]);
      setMessage(
        <p style={{ color: "green" }}>Удалено {data.length} шаблонов смен!</p>,
      );
    }
    setWorkSpinner(false);
  }

  return (
    <div className="container">
      <div className="accordion " id="accordionFlushExample">
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseOne"
              aria-expanded="false"
              aria-controls="flush-collapseOne"
            >
              Добавление шаблонов смен
            </button>
          </h2>
          <div
            id="flush-collapseOne"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="text-center" style={{ marginTop: "5%" }}>
                    Добавление шаблонов смен
                  </h1>
                </div>
                <div className="col-md-6">
                  <div className="form text-center" style={{ marginTop: "5%" }}>
                    <input
                      className="form-control"
                      type="file"
                      id="formFile"
                      onChange={addFile}
                    ></input>
                    {haveFile && (
                      <button
                        className="btn"
                        onClick={() => {
                          setWorkSpinner(true);
                          sendFile();
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                        style={{ marginTop: "5%" }}
                      >
                        Отправить
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="info" style={{ marginTop: "5%" }}>
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th className="text-center">Строки с проблемами</th>
                        </tr>
                      </thead>
                      <tbody>
                        {statusFile &&
                          statusFile.map((error, index) => (
                            <tr key={index}>
                              <td className="text-center">{error}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="col-md-12" style={{ marginTop: "5%" }}>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="text-center">
                          Успешно загруженные смены
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {loadedTemplateShifts.map((row) => (
                        <tr key={row.id}>
                          <td className="text-center">
                            {renderTempaleShift(row)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#flush-collapseTwo"
              aria-expanded="false"
              aria-controls="flush-collapseTwo"
            >
              Удаление шаблонов смен
            </button>
          </h2>
          <div
            id="flush-collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#accordionFlushExample"
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <h1 className="text-center" style={{ marginTop: "5%" }}>
                    Удаление шаблонов смен
                  </h1>
                </div>
                <div className="col-md-9">
                  <div
                    className="text-justify"
                    style={{ fontSize: "18px", marginTop: "5%" }}
                  >
                    Для того, чтобы удалить шаблоны смен, необходимо, чтобы
                    сотрудник не был записан на выбранные шаблоны смен за
                    период! Поэтому для того, чтобы удалить шаблонные смены,
                    нужно удалить со смен сотрудников, которые закреплены за
                    удаляемым шаблоном смены
                  </div>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th className="text-center">Шаблоны смен</th>
                        <th className="text-center">Смены</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deletedTemplateShifts.map((row) => (
                        <tr>
                          <td className="text-center">
                            {renderTempaleShift(row.template_shift)}
                          </td>
                          <td>{renderShift(row.shift)}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="text-center" style={{ marginTop: "5%" }}>
                    {haveTemplateShifts && (
                      <button
                        className="btn"
                        onClick={() => {
                          setWorkSpinner(true);
                          deleteTemplateShifts();
                        }}
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                      >
                        Удалить
                      </button>
                    )}
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="select-ts" style={{ marginTop: "30%" }}>
                    <select
                      className="form-select"
                      aria-label="Default select example"
                      value={selectedRestaurant}
                      onChange={(e) => setSelectedRestaurant(e.target.value)}
                    >
                      <option value={0}>Выберите Ресторан</option>
                      {restaurants.map((rest) => (
                        <option key={rest.id} value={rest.id}>
                          {rest.name}
                        </option>
                      ))}
                    </select>
                    <input
                      className="form-control"
                      type="date"
                      value={selectedStartDate}
                      onChange={(e) => setSelectedStartDate(e.target.value)}
                      style={{ marginTop: "5%" }}
                    />
                    <input
                      className="form-control"
                      type="date"
                      value={selectedEndDate}
                      onChange={(e) => setSelectedEndDate(e.target.value)}
                      style={{ marginTop: "5%" }}
                    />
                    <div className="text-center">
                      <button
                        className="btn text-center"
                        onClick={() => {
                          setWorkSpinner(true);
                          loadTemplateShifts();
                        }}
                        style={{ marginTop: "5%" }}
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop"
                      >
                        Выгрузить
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="modal-title text-center" id="staticBackdropLabel">
                Информация
              </h5>
            </div>
            <div className="modal-body text-center">
              {message}
              {workSpinner && (
                <div className="spinner-border text-danger" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddTemplateShift;
